export const FORMULARIO_PROYECTO = 'FORMULARIO_PROYECTO';
export const OBTENER_PROYECTOS = 'OBTENER_PROYECTOS';
export const AGREGAR_PROYECTOS = 'AGREGAR_PROYECTOS'; 
export const MOSTRAR_MENSAJE = 'MOSTRAR_MENSAJE'; 
export const MOSTRAR_PROYECTOS = 'MOSTRAR_PROYECTOS'; 
export const ELIMIAR_PROYECTOS = 'ELIMINAR_PROYECTOS'; 
export const PROYECTO_ERROR = 'PROYECTO_ERROR'


//TAREAS

export const TAREAS_PROYECTO = 'TAREAS_PROYECTO';
export const AGREGAR_TAREAS = 'AGREGAR_TAREAS';
export const MENSAJE_TAREAS = 'MENSAJE_TAREAS'; 
export const ELIMINAR_TAREAS = 'ELIMINAR_TAREAS';
export const SELECCIONAR_TAREAS = 'SELECCIONAR_TAREAS';
export const EDITAR_TAREAS = 'EDITAR_TAREAS';
export const LIMPIAR_TAREAS = 'LIMPIAR_TAREAS';


//ALERTAS

export const MOSTRAR_ALERTA = 'MOSTRAR_ALERTA';
export const OCULTAR_ALERTA = 'OCULTAR_ALERTA';





//REGISTRO

export const REGISTRO_EXITOSO = 'REGISTRO_EXITOSO';
export const REGISTRO_ERROR = 'REGISTRO_ERROR';
export const OBTENER_USUARIO = 'OBTENER_USUARIO';
export const LOGIN_EXITOSO = 'LOGIN_EXITOSO';
export const LOGIN_ERROR = 'LOGIN_ERROR';
export const CERRAR_SESION = 'CERRAR_SESION';


